import React from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress } from "@mui/material";

import AccessDenied from "../common/AccessDenied";
import usePermissionGate from "../../hooks/usePermissionGate";
import colors from "../../utils/colors";

export function PagePermissionLoader({ minHeight = 400 }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight,
        p: 6,
      }}
    >
      <CircularProgress size={36} sx={{ color: colors.primary[300] }} />
    </Box>
  );
}

/**
 * Waits for auth hydration before showing Access Denied (LDCP-138).
 */
const PermissionGate = ({
  children,
  permission = null,
  permissions = [],
  requireAll = false,
  resource = null,
  action = null,
  allowAdmin = true,
  resourceLabel = "this resource",
  loadingFallback = null,
  minLoaderHeight = 400,
}) => {
  const { status } = usePermissionGate({
    permission,
    permissions,
    requireAll,
    resource,
    action,
    allowAdmin,
  });

  if (status === "loading") {
    return loadingFallback ?? <PagePermissionLoader minHeight={minLoaderHeight} />;
  }

  if (status === "denied") {
    return <AccessDenied resource={resourceLabel} />;
  }

  return children;
};

PermissionGate.propTypes = {
  children: PropTypes.node.isRequired,
  permission: PropTypes.string,
  permissions: PropTypes.arrayOf(PropTypes.string),
  requireAll: PropTypes.bool,
  resource: PropTypes.string,
  action: PropTypes.string,
  allowAdmin: PropTypes.bool,
  resourceLabel: PropTypes.string,
  loadingFallback: PropTypes.node,
  minLoaderHeight: PropTypes.number,
};

export default PermissionGate;
